export const LEMNISCATE = '\u221E';

export const EMPTY_SPACE = '\u00A0';
